<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Recibos por productor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb />
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <orders-table :order-state="orderState" />
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';

import OrdersTable from './List/OrdersTable.vue';

export default {
  name: 'ReceiptsOrdersList',
  components: {
    OrdersTable,
    RouteBreadCrumb,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  computed: {
    orderState() {
      return this.$route.meta.orderState;
    },
  },
};
</script>
